// extracted by mini-css-extract-plugin
export default {"container":"tabs_container__LlVce","divider":"tabs_divider__i+M18","tabs":"tabs_tabs__Zk0JL","tab":"tabs_tab__Zacm3","count":"tabs_count__WaRJJ","active":"tabs_active__IatFP"};